var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 35,
    viewBox: "0 0 22 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76 35L0.12 19.928V16.376H3C4.152 16.376 5.16 16.216 6.024 15.896C6.92 15.544 7.656 15.048 8.232 14.408C8.84 13.768 9.256 13 9.48 12.104H0.12V8.552H9.432C9.24 7.72 8.904 6.984 8.424 6.344C7.976 5.704 7.368 5.208 6.6 4.856C5.864 4.472 4.968 4.28 3.912 4.28H0.12V0.727998H21.768V4.28H14.232C14.776 4.888 15.224 5.544 15.576 6.248C15.96 6.952 16.216 7.72 16.344 8.552H21.768V12.104H16.44C16.12 14.472 15.208 16.328 13.704 17.672C12.2 18.984 10.264 19.88 7.896 20.36L17.304 35H8.76Z",
    fill: "#444649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.b0fa8e7a354d48b5132174efd07ca01e.svg";
export { ForwardRef as ReactComponent };